import { Permission, PermissionEntityType } from "../types/permissionType";
import { CallResult, doApiGet, doApiPost, doApiDelete } from "./Requests";

export const permissionsApi = {
    getAllPermissions: async (): Promise<CallResult<Permission[]>> => {
        return await doApiGet<Permission[]>("/api/permissions/definitions");
    },

    getSingleUserPermission: async (
        userId: string
    ): Promise<CallResult<Permission[]>> => {
        return await doApiGet<Permission[]>(`/api/users/${userId}/permissions`);
    },

    addGeneralPermission: async (
        userId: string,
        entityType: PermissionEntityType,
        permissionName: string
    ): Promise<CallResult<null>> => {
        return await doApiPost<void, null>(
            `/api/users/${userId}/permissions/${entityType}/${permissionName}`,
            undefined
        );
    },

    removeGeneralPermission: async (
        userId: string,
        entityType: PermissionEntityType,
        permissionName: string
    ): Promise<CallResult<null>> => {
        return await doApiDelete<null>(
            `/api/users/${userId}/permissions/${entityType}/${permissionName}`
        );
    },

    addEntityPermission: async (
        userId: string,
        entityType: PermissionEntityType,
        permissionName: string,
        targetEntityId: number
    ): Promise<CallResult<null>> => {
        return await doApiPost<void, null>(
            `/api/users/${userId}/permissions/${entityType}/${permissionName}/${targetEntityId}`,
            undefined
        );
    },

    removeEntityPermission: async (
        userId: string,
        entityType: PermissionEntityType,
        permissionName: string,
        targetEntityId: number
    ): Promise<CallResult<null>> => {
        return await doApiDelete<null>(
            `/api/users/${userId}/permissions/${entityType}/${permissionName}/${targetEntityId}`
        );
    },
};
